export default (type: string, payload?: any): any => ({
  type,
  payload,
})
